import styled from 'styled-components';

export const PageLayoutStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // overflow-x: hidden;
  max-width: 100vw;
`;
